import React from 'react';
import CarePartnersManager from '../careReferrals/CarePartnersManager';

export default function HeadDoctorCarePartnersPage() {
  return <CarePartnersManager />;
}
